<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input v-model="email" type="text" class="form-control" placeholder="Email" autocomplete="username email" />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-key"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input v-model="password" type="password" class="form-control" placeholder="Password" autocomplete="current-password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button v-on:click="login()" variant="primary" class="px-4">Login</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
              <b-card-footer class="mb-3">
              <b-row>
                <b-col cols="12">
                  tidak punya akun ? silahkan <router-link to="/auth/register">Register</router-link> 
                </b-col>
              </b-row>
            </b-card-footer>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import router from '@/router/index'
import axios from "axios"
import constant from "../../utils/constant.js"
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      flag : '',
      messages : '',
    }
  },
  computed:{
    
  },
  watch: {

  },
  methods:{
      login(){
          var data = {
              "email": this.email,
              "password" : this.password
          }

          axios.post(constant._BASE_URL+"login",data)
            .then(response => {
                console.log(response)
                localStorage.setItem(`user_token`, response.data.success['token']);
                localStorage.setItem(`user_name`, response.data.success['user_name']);
                localStorage.setItem(`user_email`, response.data.success['user_email']);
                localStorage.setItem(`user_id`, response.data.success['user_id']);
                localStorage.setItem(`user_logo`, response.data.success['user_logo']);
                localStorage.setItem(`user_isloggedIn`, true);

                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Login Berhasil',
                  showConfirmButton: false,
                  timer: 1500
                })
                router.push({name: 'Dashboard'})
            })
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/Login.vue